import { DateTime } from 'luxon';
import {
  TransferInfo,
  TransferInfoZod,
  TransferListData,
  TransferListDataZod,
} from '../model';
import { delet, get, post } from './BaseApi';
import { z } from 'zod';
import { zodStringToDateTime } from '../utils';

export async function getTransferOutInfo(
  studentId: string
): Promise<TransferInfo> {
  return await get(`/api/transfer/student/${studentId}`, TransferInfoZod);
}

export async function getTransferInInfo(
  studentId: string,
  birth: DateTime
): Promise<TransferInfo> {
  return await get(`/api/transfer/student/${studentId}/data`, TransferInfoZod, {
    birth: birth.toISO(),
  });
}

export async function getSHISTransferInInfo(
  studentId: string,
  birth: DateTime
): Promise<TransferInfo> {
  return await get(
    `/api/transfer/student/${studentId}/data/formshis`,
    TransferInfoZod,
    {
      birth: birth.toISO(),
    }
  );
}

export async function transferOut(studentId: string): Promise<void> {
  await post(`/api/transfer/student/${studentId}/out`);
}

export async function transferOutToShis(studentId: string): Promise<void> {
  await post(`/api/transfer/student/${studentId}/out`);
}

export async function transferOutTest(studentId: string): Promise<object> {
  const response = await post(`/api/transfer/student/${studentId}/out/test`);
  return response as unknown as object;
}

export async function deleteStudent(
  studentId: string,
  type: number,
  year: number,
  sem: number,
  reason: string
): Promise<void> {
  await post(`/api/transfer/student/${studentId}/delete/${type}/${year}/${sem}`, { reason });
}

export async function transferIn(
  transferId: number,
  data: {
    sid: string;
    seat: number;
    year: number;
    sem: number;
    classGrade: number;
    classNo: number;
  }
): Promise<void> {
  await post(`/api/transfer/${transferId}/in`, data);
}

export async function getTransferList(
  year: number,
  grade: number,
  filter: string
): Promise<TransferListData[]> {
  return await get(`/api/transfer/students`, z.array(TransferListDataZod), {
    year,
    grade,
    filter,
  });
}

export async function RequestTransferOut(
  pid: string,
  birth: DateTime
): Promise<void> {
  await post('/api/transfer/out/request', { pid, birth: birth.toISO() });
}

export async function updateStudentTransferDone(pid: string): Promise<void> {
  await post(`/api/transfer/out/update/${pid}/transferdone`);
}

export async function updateOtherSchooldData(pid: string): Promise<void> {
  await post(`/api/transfer/out/update/${pid}/otherschool/data`);
}

const requestList = z.array(zodStringToDateTime());
export async function GetTransferRequestList(
  pid: string
): Promise<z.infer<typeof requestList>> {
  return await get('/api/transfer/out/requests', requestList, { pid });
}
